const MONTHS = [
  "yanvar", "fevral", "mart", "aprel", "may", "iyun",
  "iyul", "avgust", "sentabr", "oktabr", "noyabr", "dekabr",
];

/**
 * "15-sentabr, 2026". Oy nomlari qo'lda — brauzerlarda `uz-UZ` uchun
 * ma'lumot ko'pincha yo'q va Intl jimgina ruschaga o'tib ketadi.
 */
export function formatDate(iso: string): string {
  const [year, month, day] = iso.split("-").map(Number);
  if (!year || !month || !day) return iso;
  return `${day}-${MONTHS[month - 1]}, ${year}`;
}
